import {
  ModelVersionENV,
  ModelVersionENVValues,
  ModelVersionESS,
  ModelVersionESSValues,
} from '@/domain/project/entities/project.entity';
import { ProjectVenue } from '@/domain/project-venue/entities/project-venue.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { ProjectVenueDto } from './project-venue.dto.schema';

type ProjectVenueDtoOmitId = Omit<ProjectVenueDto, 'id' | 'models' | 'venue'>;

export class ProjectVenueMapper {
  static dtoToEntity(dto: ProjectVenueDto): ProjectVenue {
    return {
      id: dto.id,
      organisationId: dto.organisationId,
      type: 'venue',
      name: dto.name,
      image: dto.image || '',
      startDate: dto.startDate,
      endDate: dto.endDate,
      location: dto.location,
      maxCapacity: dto.properties?.avgCapacity || 0,
      models: {
        structure: {
          ess: validateValueInType<ModelVersionESS>(
            dto.models.structure.ess,
            ModelVersionESSValues,
          ),
          env: validateValueInType<ModelVersionENV>(
            dto.models.structure.env,
            ModelVersionENVValues,
          ),
        },
        events: {
          ess: validateValueInType<ModelVersionESS>(
            dto.models.events.ess,
            ModelVersionESSValues,
          ),
          env: validateValueInType<ModelVersionENV>(
            dto.models.events.env,
            ModelVersionENVValues,
          ),
        },
      },
      properties: {
        presetTitle: dto.properties?.presetTitle || '',
        avgCapacity: dto.properties?.avgCapacity || 0,
        accommodation: dto.properties?.accommodation || [],
        equipment: dto.properties?.equipment || [],
        mobility: dto.properties?.mobility || [],
      },
    };
  }

  static entityToDto(project: ProjectVenue): ProjectVenueDtoOmitId {
    return {
      organisationId: project.organisationId || 0,
      image: project.image,
      name: project.name,
      location: project.location,
      startDate: project.startDate
        ? new Date(project.startDate).toISOString()
        : null,
      endDate: project.endDate ? new Date(project.endDate).toISOString() : null,
      properties: {
        avgCapacity: project.maxCapacity || 0,
      },
    };
  }
}
